import React, { useEffect , Fragment , useState} from "react";
import { Dialog, DialogActions, DialogTitle } from "../../../Components/Dialog/DialogComponent";
import { ButtonDefault } from "../../../Components/Button/Buttoncontainer";
import "../../../Components/Tetimonials/Testimonials.css"
import { listJobPost } from './../../../services/career';

const Careers = () => {
  const [tabValue, setTabValue] = useState(0);
  const [isDialogOpen,setIsDialogOpen] = useState(false);
  const [isDialog2Open,setIsDialog2Open] = useState(false);
  const [listOfPosts,setListOfPosts] = useState([])
  const handleChange = (value: any) => {
    setTabValue(value);
  };  
  useEffect(()=>{
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    getJobList()
  },[])

  const getJobList = async ()=>{
    try {
      let queryData = {
        page : 1,
        pageSize : 10,
      }
      let ans = await listJobPost(queryData);
      setListOfPosts(ans);
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <Fragment>
      <section className="careers">
        <div className="positionLatest cta-text">
          <h3>JOIN TAPTAP</h3>
          <p className="pText">
            Help us build the smartest transport logistics platform in the
            world.
          </p>
          <p className="pText">
            It is a long established fact that a reader will be distracted
            by the readable content of a page when looking at its layout.
            The point of using Lorem Ipsum is that it has a more-or-less
            normal distribution of letters, as opposed to using 'Content
            here, content here', making it look like readable English. Many
            desktop publishing packages and web page editors now use Lorem
            Ipsum as their default model text, and a search for 'lorem
            ipsum' will uncover many web sites still in their infancy.
            Various versions have evolved over the years, sometimes by
            accident, sometimes on purpose (injected humour and the like).
          </p>
        </div>
        <div className='homePageDiv'>
              <div className='headingNavbar'>
                <div className='homePageHeadingTabs'>
                  <div className={tabValue === 0 ? "sixTabs active" : "sixTabs"} onClick={()=>handleChange(0)}>IT Engineer</div>
                  <div className={tabValue === 1 ? "sixTabs active" : "sixTabs"} onClick={()=>handleChange(1)}>Branch Manager</div>
                  <div className={tabValue === 2 ? "sixTabs active" : "sixTabs"} onClick={()=>handleChange(2)}>Branch Executive</div>
                  <div className={tabValue === 3 ? "sixTabs active" : "sixTabs"} onClick={()=>handleChange(3)}>Tele Calling Support</div>
                  <div className={tabValue === 4 ? "sixTabs active" : "sixTabs"} onClick={()=>handleChange(4)}>Fleet Driver</div>
                  <div className={tabValue === 5 ? "sixTabs active" : "sixTabs"} onClick={()=>handleChange(5)}>Branch Labour</div>
                </div>
              </div>
        </div>
        <div className="careersMainDiv">
          {listOfPosts.map((e:any)=>{
            console.log(e)
            return (
            <section className="pn_reviews my-5" key={e._id}>
                <div className="careers_Box">
                    <img src="https://taptap.in/img/tap8.png" alt="TapTap.in" height={"10%"} width={"35%"} style={{marginLeft:"33%",marginBottom:"2.5%"}} />
                    <div style={{padding:"2% 5%",lineHeight:'35px'}}>
                      <div className="tac" style={{fontSize:"x-large",fontWeight:"bold",marginBottom:"20px"}}>{e.jobTitle}</div>
                      <div className="tac">{e.company.companyName}</div>
                      <div className="tac">{e.location.state}</div>
                      <div className="tac">Salary :- 15K to 25K</div>
                    </div>
                    <div style={{border:"0.2px solid transparent",display:"flex",justifyContent:"space-between",width:"90%",margin:"auto",marginTop:"5%"}}>
                    <button onClick={()=>{setIsDialogOpen(!isDialogOpen)}}> Job Description </button>
                      <>  
                        <Dialog
                            open={isDialogOpen}
                            onClose={() => setIsDialogOpen(false)}
                            maxWidth={"lg"}
                            >
                            <div className='tac bold'>
                                <DialogTitle
                                id="draggable-dialog-title"
                                >
                                Add Package Info
                                </DialogTitle>
                            </div>
                            
                            <div className="tac">Prahalad Nagar , Ahmedabad (on-site)</div>
                            <DialogActions>
                            <div className='dflex w100'>
                                <ButtonDefault
                                className="mr5"
                                onClick={() => setIsDialogOpen(false)}
                                >
                                close
                                </ButtonDefault>
                            </div>
                            </DialogActions>
                        </Dialog>
                      </>
                    <button onClick={()=>{setIsDialog2Open(!isDialog2Open)}}> Apply Now </button>
                      <>  
                        <Dialog
                            open={isDialog2Open}
                            onClose={() => setIsDialog2Open(false)}
                            maxWidth={"lg"}
                            >
                            <div className='tac bold'>
                                <DialogTitle
                                id="draggable-dialog-title"
                                >
                                Fill up the Form
                                </DialogTitle>
                            </div>
                            
                            <div className="tac">Prahalad Nagar , Ahmedabad (on-site)</div>
                            <DialogActions>
                            <div className='dflex w100'>
                                <ButtonDefault
                                className="mr5"
                                onClick={() => setIsDialog2Open(false)}
                                >
                                close
                                </ButtonDefault>
                            </div>
                            </DialogActions>
                        </Dialog>
                      </>
                    </div>
                    <div style={{display:"flex",gap:"10%",marginLeft:"22%",marginTop:"5%"}}>
                      <div><i className="fa fa-calendar" aria-hidden="true"></i> 22-09-22</div>
                      <div><i className="fa fa-user" aria-hidden="true"></i> 101</div>
                    </div>
                </div>
            </section>  
              )
          })}
        </div>
      </section>
    </Fragment>
  );
};

export default Careers;
